import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Getcover from './pages/Getcover';
import Activepolicies from './pages/Activepolicies';
import Bulkprocessing from './pages/Bulkprocessing';
import Extensions from './pages/Extensions';
import Notes from './pages/Notes';
import Upcomingrenewals from './pages/Upcomingrenewals';
import Expired from './pages/Expired';
import Documents from './pages/Documents';
import Generatedcertificates from './pages/Generatedcertificates';
import Failedcertificates from './pages/Failedcertificates';
import Claims from './pages/Claims';
import Productionreport from './pages/Productionreport';
import Commissionreport from './pages/Commissionreport';
import Wallet from './pages/Wallet';
import Doubleinsurance from './pages/Doubleinsurance';
// import Pending from './pages/Pending';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/get-cover" element={<Getcover />} />
        <Route path="/active-policies" element={<Activepolicies />} />
        <Route path="/bulk-processing" element={<Bulkprocessing />} />
        <Route path="/extensions" element={<Extensions />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/renewals/due" element={<Upcomingrenewals />} />
        <Route path="/renewals/expired" element={<Expired />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/generated-certificates" element={<Generatedcertificates />} />
        <Route path="/failed-certificates" element={<Failedcertificates />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/reports/production" element={<Productionreport />} />
        <Route path="/reports/commission" element={<Commissionreport />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/double-insurance" element={<Doubleinsurance />} />
        {/* <Route path="/pending-proposals" element={<Pending />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
